import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-accessibility-content',
  templateUrl: './accessibility-content.component.html',
  styleUrls: ['./accessibility-content.component.css']
})
export class AccessibilityContentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
